export enum TreatmentCategory {
  Normal = 0,
  Special = 1,
}

export const TreatmentCategories = [
  TreatmentCategory.Normal,
  TreatmentCategory.Special,
];

// XPS(1, "需皮试"), PX(2, "皮（续）"), PIYIN(3,"皮（阴）"), PIYANG(4,"皮（阳）");
export enum SkinTestStatus {
  None = 0,
  NeedATest = 1,
  Continue = 2,
  Negative = 3,
  Positive = 4,
}

const TreatmentCategoryNames = ["普通", "特病"];

export function getTreatmentCategoryName(category: TreatmentCategory): string {
  if (category < 0 || category >= TreatmentCategoryNames.length) {
    return "";
  }
  return TreatmentCategoryNames[category];
}

export interface Treatment {
  id: string;
  chiefComplaint: string;
  disease: string;
  furtherConsideration: number;
  historyOfPresentIllness: string;
  infectiousDisease: number;
  inspectionCheck: string;
  medicalHistory: string;
  personalHistory: string;
  familyHistory: string;
  vaccineHistory: string;
  menstrualHistory: string;
  maritalHistory: string;
  pastMedicalHistory: string;
  patientDiastolicPressure: string;
  patientHeight: string;
  patientId: string;
  patientName: string;
  patientSex: number;
  patientAge: number;
  patientMonth: number;
  patientPulse: string;
  patientSystolicPressure: string;
  patientTemperature: string;
  patientWeight: string;
  physicalExamination: string;
  registrationId: string;
  status: string;
  treatmentCategory: number;
  treatmentDepartmentId: string;
  treatmentDepartmentName: string;
  treatmentDoctorId: string;
  treatmentDoctorName: string;
  treatmentConclusion: string;
  createTime: string;
  receiveTag: number;
  chargeOrRefundTime: string;
  medicalRecord: number;
  //口腔新增字段
  stomatologyCheck?: string;
  treatmentPlan?: string;
  disposeContent?: string;
  stomatologyTooth?: string;
  inspectionTooth?: string;
  diseaseTooth?: string;
  treatmentTooth?: string;
  disposeTooth?: string;
  //中医新增字段
  pulseCondition?: string;
  tonguePicture?: string;
  // 文件上传
  coherentVideo?: string;
}

export function fromJson(json: any): Treatment {
  return {
    id: json.id?.toString() || "",
    chiefComplaint: json.chiefComplaint,
    disease: json.disease,
    furtherConsideration: json.furtherConsideration,
    historyOfPresentIllness: json.historyOfPresentIllness,
    infectiousDisease: json.infectiousDisease,
    inspectionCheck: json.inspectionCheck,
    medicalHistory: json.medicalHistory,
    personalHistory: json.personalHistory,
    familyHistory: json.familyHistory,
    vaccineHistory: json.vaccineHistory,
    menstrualHistory: json.menstrualHistory,
    maritalHistory: json.maritalHistory,
    pastMedicalHistory: json.pastMedicalHistory,
    patientDiastolicPressure: json.patientDiastolicPressure,
    patientHeight: json.patientHeight,
    patientId: json.patientId?.toString() || "",
    patientName: json.patientName,
    patientSex: json.patientSex,
    patientAge: json.patientAge > 0 ? json.patientAge : 0,
    patientMonth: json.patientMonth > 0 ? json.patientMonth : 0,
    patientPulse: json.patientPulse,
    patientSystolicPressure: json.patientSystolicPressure,
    patientTemperature: json.patientTemperature,
    patientWeight: json.patientWeight,
    physicalExamination: json.physicalExamination,
    registrationId: json.registrationId?.toString() || "",
    status: json.status,
    treatmentCategory: json.treatmentCategory,
    treatmentDepartmentId: json.treatmentDepartmentId?.toString() || "",
    treatmentDepartmentName: json.treatmentDepartmentName,
    treatmentDoctorId: json.treatmentDoctorId?.toString() || "",
    treatmentDoctorName: json.treatmentDoctorName,
    treatmentConclusion: json.treatmentConclusion,
    createTime: json.createTime,
    receiveTag: json.receiveTag,
    chargeOrRefundTime: json.chargeOrRefundTime,
    medicalRecord: json.medicalRecord,
    stomatologyCheck: json.stomatologyCheck,
    treatmentPlan: json.treatmentPlan,
    disposeContent: json.disposeContent,
    stomatologyTooth: json.stomatologyTooth,
    inspectionTooth: json.inspectionTooth,
    diseaseTooth: json.diseaseTooth,
    treatmentTooth: json.treatmentTooth,
    disposeTooth: json.disposeTooth,
    pulseCondition: json.pulseCondition,
    tonguePicture: json.tonguePicture,
    coherentVideo: json.coherentVideo,
  };
}

export interface TreatmentNotice {
  minMedicationDay: number;
  recentlyTreatmentTime: string;
}
